'use strict';

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const TimeSeries=require('pulsar-dashboard-core/dist-es6/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const PointPlotterDirective=require('../../../../dist-es6/client/directives/plotting/pointPlotterDirective');let

SvgPlotterDirective=class SvgPlotterDirective extends PointPlotterDirective{
get textBindings(){
return['svg',...super.textBindings];
}

get objectBindings(){
return['svgs','verticalAxis','pointRadius','tooltipText',...super.objectBindings];
}

get controller(){
return SvgPlotterController;
}};let


SvgPlotterController=class SvgPlotterController extends PointPlotterDirective.Controller{
static get $inject(){
return['$scope','$element','$compile'];
}

constructor($scope,$element,$compile){
super($scope,$element,$compile);

this.hitAreaWidth=this.pointRadius*2;
this._iconHeight=this.pointRadius*4;
}

_getPointInfos(times){
return times.map(({time,tooltipText,status},index)=>({
time,
index,
x:this.horizontalAxis.scale(time.getTime()),
y:this.plotArea.graphAreaDimensions.height/2,
tooltipText,
status}));

}

_getHitAreaInfos(){
const getYPos=({y})=>this.plotArea.graphAreaBoundaries.top;
const getHeight=({y})=>this.plotArea.graphAreaDimensions.height;

return{
x:({x})=>x-this.pointRadius,
y:getYPos,
width:this.hitAreaWidth,
height:getHeight,
fill:'transparent',
class:this.class};

}

_precompileStep(d3Selection){
d3Selection.selectAll('image').
data(this._getPointInfos(this.points)).
enter().
append('image').
attr({
"xlink:href":({status})=>this.svg||this.svgs[status],
width:this.pointRadius*2,
height:this.pointRadius*2,
x:({x})=>x-this.pointRadius,
y:({y})=>y-this.pointRadius}).

style('pointer-events','none');
}};


module.exports=SvgPlotterDirective;
//# sourceMappingURL=svgPlotterDirective.js.map
